// global中的信息
export const source = state => state.global.source; // 完整简历3，M微简历13，联盟18
export const resumeType = state => state.global.resumeType; // 完整简历1，M微简历2，联盟3
export const user58pic = state => state.global.user58pic; // 58用户头像
export const jobUrl = state => state.global.jobUrl; // 达到6份后的引导职位列表页链接
export const categoryInitList = state => state.global.categoryInitList; // 默认选择的职位

// 页面来源（区分微简历/联盟以及是否登录）
export const pagefromLog = state => {
	let suffix = ''; // 后缀

	// 埋点中需要区分初始登录状态
	if (state.global.isLogin) {
		suffix += '_login';
	} else {
		suffix += '_nologin';
	}

	// 微简历/联盟区分
	if (state.global.resumeType === 2) {
		suffix += '_micro';
	} else if (state.global.resumeType === 3) {
		suffix += '_union';
	}

	return suffix; // 简历来源log标识
};

// 页面类型（只区分微简历/联盟简历，不区分登录态）
export const pagetypeLog = state => {
	let suffix = ''; // 后缀

	// 微简历/联盟区分
	if (state.global.resumeType === 2) {
		suffix += '_micro';
	} else if (state.global.resumeType === 3) {
		suffix += '_union';
	}

	return suffix; // 简历来源log标识
};

// 基本简历状态信息
export const pagefromUrl = state => state.pagefromUrl;
export const isLogin = state => {
	return state.isLogin;
};
export const pagefrom = state => state.pagefrom; // 页面来源
export const resumeCount = state => state.resumeCount;
export const basicInfo = state => state.basicInfo;
export const basicInfoOk = state => state.basicInfoOk;
export const expectionInfo = state => state.expectionInfo;
export const expectionInfoOk = state => state.expectionInfoOk;

// 手机号相关信息
export const hasAuthedMobile = state => state.hasAuthedMobile; // 后置登录使用的手机号或已通过认证的手机号
export const authMobile = state => state.authMobile; // 已认证手机号
export const hasAuthed = state => state.hasAuthed; // 手机号是否已认证
export const getCaptchaState = state => state.captcha.isSuccess; // 获取验证码状态
export const getCaptchaErrorInfo = state => state.captcha.errorInfo; // 获取验证码失败错误信息
export const checkCodeRight = state => state.basicInfo.keyCode; // 验证码是否正确

// 基本信息
export const pic = state => state.submitData.pic;
export const originPic = state => state.originPic;
export const truename = state => state.submitData.truename;
export const gender = state => state.submitData.gender;
export const mobile = state => state.submitData.mobile;
export const birthday = state => state.submitData.birthday.split('-')[0];
export const education = state => state.submitData.education;
export const workyears = state => state.submitData.workyears;
export const educations = state =>
	JSON.parse(state.submitData.educations || '[]');
export const infoId = state => state.infoId; // 职位id

// 期望信息
export const sessionCateList = state => state.sessionCateList;
export const salary = state => state.submitData.salary;
export const sessionAreaList = state => state.sessionAreaList;

// 隐私设置信息
export const showStatus = state => state.privacyData.showStatus;
export const showIndustry = state => state.showIndustry;
export const blockIndustry = state => state.privacyData.blockIndustry;

// 保存简历接口返回结果
export const resumeId = state => state.resumeId;
export const submitState = state => state.submitState;
export const submitErrorInfo = state => state.submitErrorInfo;
export const privacySettingState = state => state.privacySettingState;
export const privacyErrorInfo = state => state.privacyErrorInfo;

// 选择区域列表
export const areaInfo = state => state.areaInfo;
export const areaName = state =>
	state.global.areaName ? state.global.areaName : '北京'; // 当前城市名称(默认北京)

// 头像上传结果
export const uploadState = state => state.uploadState; // 头像上传结果

// 投递返回code
export const deliveryCode = state => state.deliveryCode; // 投递返回code

// 投递的状态
export const deliveryState = state => state.deliveryState; // 投递返回code

// 投递错误提示
export const deliveryMsg = state => state.deliveryMsg; // 投递返回code

// 教育经历相关
export const educationInfo = state => state.educationInfo;
export const educationCheck = state => state.educationCheck;
export const educationOk = state => state.educationOk;

export const gradschool = state => state.educationInfo.gradschool;
export const gradmajor = state => state.educationInfo.gradmajor;
export const gradtime = state => state.educationInfo.gradtime;
export const eduIndex = state => state.educationInfo.eduIndex;
export const eduState = state => state.educationInfo.eduState;

// 滑块验证码
export const showISDCaptcha = state => state.showISDCaptcha;
export const responseObj = state => state.responseObj;

// 静态数据
export const allConfigOtherData = state => state.allConfigOtherData;


// WEBPACK FOOTER //
// ./src/module/basic/store/getters.js